import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { BehaviourType } from './types';

const useGetBehaviours = () => {
  const [behaviours, setBehaviours] = useState<BehaviourType[]>([]);
  const [loading, setLoading] = useState(true);

  const getBehaviours = async () => {
    setLoading(true);
    try {
      const response = await api.get('/disposition_option/behaviour');
      setBehaviours(response.data);
    } catch (error) {
      toast.error('Erro ao carregar os comportamentos. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to load disposition option behaviours'), {
        error,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBehaviours();
  }, []);

  return {
    behaviours,
    loading,
  };
};

export default useGetBehaviours;
